// export default 'http://' + window.location.hostname + ':64368/api'
// export default 'http://' + window.location.hostname + ':64367/api'
// export default `${window.location.protocol}//api1.imea.com.br/api`
// export default 'http://' + window.location.hostname + ':64368/api'
// export default 'http://192.168.0.18:64367/api'
// export default 'http://192.168.1.14:30130/api'
// export default 'http://192.168.0.12:30130/api'
// export default 'http://sydy.ddns.net:64368/api'
export default process.env.VUE_APP_BASE_URL
